export const EXODUS_ASSET_NAME_TO_TOKEN_NAME = {
    '27g8_solana_fec754b1': 'jupiter',
    '3s8q_solana_d40f407e': 'mother',
    '5ovn_solana_9674e260': 'infinity',
    '9n4n_solana_c5cba5c4': 'bitcoin',
    aave_matic_bfdf3c37: 'aave',
    aave: 'aave',
    aave_ethereumarbone_5099d765: 'aave',
    aave_optimism_a1ee4be5: 'aave',
    audius: 'audius',
    audius_solana: 'audius',
    avalanchec: 'avalanche',
    basemainnet: 'ether',
    bitcoin: 'bitcoin',
    bitcoinregtest: 'bitcoin',
    bitcointestnet: 'bitcoin',
    bonk_avalanchec_19731115: 'bonk',
    bonk_basemainnet_a8e9f03c: 'bonk',
    bonk_bsc_a9f11a09: 'bonk',
    bonk_ethereum_1026a578: 'bonk',
    bonk_ethereumarbone_0f16767c: 'bonk',
    bonk_matic_7caf4ce8: 'bonk',
    bsc: 'binance-coin',
    bybi_solana_8734b79d: 'bbsol',
    celo_evm0xa4ec_4bc2ede3: 'celo',
    clou_solana_0102bbac: 'cloud',
    drif_solana_550a9213: 'drift',
    eth_bsc_f1d2a904: 'ether',
    epjf_solana_affa629e: 'usdc',
    ethereum: 'ether',
    ethereumarbone: 'ether',
    ethereumarbonesepolia: 'ether-sepolia',
    ethereumholesky: 'ether-sepolia',
    evm0x144: 'ether',
    evm0x343b: 'immutable',
    evm0x504: 'moonbeam',
    evm0x52415249: 'ether',
    evm0xa4ec: 'celo',
    evm0xec0: 'ether',
    evm0xff: 'ether',
    evm0xaa36a7: 'ether-sepolia',
    degen_basemainnet_fa618f1e: 'degen',
    dezx_solana_3b523050: 'bonk',
    fox: 'shapeshift',
    fox_ethereumarbone_c7413022: 'shapeshift',
    fox_matic_49a6df8f: 'shapeshift',
    fox_optimism_74c6465f: 'shapeshift',
    he1i_solana_51bbcb5a: 'hsol',
    index_ethereum_4f445366: 'index-coop',
    j1to_solana_77b92a1f: 'jitosol',
    jup_ethereum_facea4ef: 'jupiter',
    jupy_solana_ed7ebe51: 'jupiter',
    kmno_solana_3c176032: 'kamino',
    'magic-eden': 'magic-eden',
    mantle: 'mantle',
    mantlesepolia: 'mantle',
    matic: 'polygon',
    mnt_ethereum_f52ca000: 'mantle',
    op_optimism_4a7ee59d: 'optimism',
    optimism: 'ether',
    optimism_mainnet: 'optimism',
    qi_avalanchec_19fd2065: 'benqi',
    quick_ethereum_012ad0c1: 'quickswap',
    quick_evm0xec0_69c5be10: 'quickswap',
    quick_matic_257e11ee: 'quickswap',
    rarible: 'rarible',
    raydium: 'raydium',
    rune_ethereum_9ca960af: 'thorchain',
    savax_avalanchec_4c4408bd: 'staked-avax',
    solana: 'solana',
    solanadevnet: 'solana',
    solanatestnet: 'solana',
    sqr_bsc_2fadeb84: 'magic-square',
    tnsr_solana_c76d67b9: 'tensor',
    tether: 'tether',
    tetherusd_solana: 'tether',
    tetherusd: 'tether',
    thor_ethereum_4b359aa3: 'thorswap',
    uni_bsc_98044f4e: 'uniswap',
    uni_ethereumarbone_0ec9ff59: 'uniswap',
    uni_matic_15e866e6: 'uniswap',
    uniswap: 'uniswap',
    usdc_avalanchec_185c8bd7: 'usdc',
    usdc_basemainnet_b5a52617: 'usdc',
    usdc_ethereum_50a85959: 'usdc',
    usdc_ethereumarbone_2e1129c4: 'usdc',
    usdc_evm0x144_a3587198: 'usdc',
    usdc_evm0xa4ec_ef809aef: 'usdc',
    usdc_matic_0a883d9b: 'usdc',
    usdc_optimism_68bb70cd: 'usdc',
    usdcoin_bsc: 'usdc',
    usdcoin_solana: 'usdc',
    usdcoin_solanadevnet: 'usdc',
    usdcoin: 'usdc',
    usdt_avalanchec_d80c1afa: 'tether',
    usdt_bsc_ddedf0f8: 'tether',
    usdt_ethereumarbone_efa95268: 'tether',
    usdt_matic_86e249c1: 'tether',
    usdt_optimism_26487766: 'tether',
    vcx_ethereum_df18ad33: 'vaultcraft',
    vrtx_ethereum_ad8416ab: 'vertex',
    vrtx_ethereumarbone_99655190: 'vertex',
    wbtc: 'bitcoin',
    wbtc_matic_298d6ace: 'bitcoin',
    weth: 'ether',
    weth_ethereumarbone_c53d6bd0: 'ether',
    weth_matic: 'ether',
    yeet_matic_1d3e2de5: 'yeet',
};
